import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { EditableSelect } from '../../components';
import { getUserFullName } from '../../utils/utilsChat';
import styles from './RoomFilter.scss';

const mapStateToProps = state => {
  return {
    currentOperator: state.currentOperator,
    currentRoomFilter: state.currentRoomFilter,
    currentCompanyOperators: state.currentCompanyOperators,
  };
};

@connect(mapStateToProps)
export class RoomFilter extends Component {

  state = {
    filterOptions: [],
  };

  componentDidMount(){
    this.setOperatorSelectOptions();
  }

  componentDidUpdate(prevProps){
    const { currentCompanyOperators } = this.props;
    if (currentCompanyOperators !== prevProps.currentCompanyOperators) {
      this.setOperatorSelectOptions();
    }
  }

  setOperatorSelectOptions = () => {
    const { currentOperator, currentCompanyOperators } =  this.props;

    const otherOperators = currentCompanyOperators
      .filter(operator => operator.id !== currentOperator.id)
      .map(operator => {
        return {
          value: operator.id,
          title: getUserFullName(operator),
        };
      })
      .sort((a,b) => {
        return a.title < b.title ? -1 : 1;
      });

    const filterOptions = [
      {
        value: currentOperator.id,
        title: 'Мои чаты',
      },
      ...otherOperators,
      {
        value: 'all-rooms',
        title: 'Все чаты',
        dividerAbove: true,
      },
      {
        value: 'new-rooms',
        title: 'Только новые чаты',
        dividerAbove: true,
      },
    ];
    this.setState({ filterOptions });
  };

  render(){
    const { filterOptions } = this.state;
    const { className, currentRoomFilter, onChange } = this.props;

    return (
      <div className={cn(className, styles.container)}>
        <EditableSelect
          overrideClassNames={{ list: styles.selectList }}
          defaultValue={currentRoomFilter}
          onChange={({ value }) => onChange(value)}
          options={filterOptions}/>
      </div>
    );
  }
}
